import { render } from "./AddPropertyView.vue?vue&type=template&id=4dd393a8&scoped=true"
import script from "./AddPropertyView.vue?vue&type=script&lang=js"
export * from "./AddPropertyView.vue?vue&type=script&lang=js"

import "./AddPropertyView.vue?vue&type=style&index=0&id=4dd393a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd393a8"]])

export default __exports__